import { Link } from "react-router-dom";

/**
 * Turn any editor-supplied menu `path` into a real Link href.
 *
 *   ""              → /{slug}
 *   "categories"    → /{slug}/categories
 *   "page/about"    → /{slug}/page/about
 *   "/category/..." → /{slug}/category/...
 *   "https://..."   → passed through as an absolute URL
 */
export function makeHref(base, path) {
  if (!path) return `${base}/`;
  if (/^https?:\/\//i.test(path)) return path;
  if (path.startsWith("#")) return `${base}${path}`;
  if (path.startsWith("/")) return `${base}${path}`;
  return `${base}/${path}`;
}

export function isExternalMenuPath(path) {
  return /^https?:\/\//i.test(path || "");
}

/** Missing `open_in_new_tab` keeps the old rule: full URLs in a new tab. */
export function opensInNewTab(item) {
  if (item?.open_in_new_tab === true) return true;
  if (item?.open_in_new_tab === false) return false;
  return isExternalMenuPath(item?.path);
}

export function SmartLink({ base, item, testid, onClick, className, style, children }) {
  const href = makeHref(base, item.path);
  const newTab = opensInNewTab(item);
  const label = children ?? item.label;
  if (isExternalMenuPath(item.path) || newTab) {
    return (
      <a
        href={href}
        target={newTab ? "_blank" : undefined}
        rel={newTab ? "noopener noreferrer" : undefined}
        className={className}
        style={style}
        data-testid={testid}
        onClick={onClick}
      >
        {label}
      </a>
    );
  }
  return <Link to={href} className={className} style={style} data-testid={testid} onClick={onClick}>{label}</Link>;
}

/** Homepage slider CTA; empty string means the slide is not a link. */
export function slideCtaHref(base, path) {
  const p = String(path || "").trim();
  if (!p) return null;
  return makeHref(base, p);
}

export function menuChildren(item) {
  return Array.isArray(item?.children) ? item.children.filter((c) => c && (c.label || c.path)) : [];
}
